// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ce53d40f","963":"b5668c30"}[chunkId] + ".chunk.js";
};